import { makeStyles } from "@material-ui/core";
import { format } from "date-fns";
import * as React from "react";

const getDateString = (date: string) => {
  const [startDate, endDate, outputDateFormat] = date.split("--");
  if (startDate == endDate) return format(new Date(startDate), "dd/MM/y");
  else if( outputDateFormat == "wo") return `${format(new Date(startDate), "wo")} Week ${format(new Date(startDate), "y")}`;
  else return `${format(new Date(startDate), outputDateFormat)}`;
};

const useStyles  = makeStyles((theme)=>({
  tooltipColorDot:{
    borderRadius: "50%",
    marginTop: 6,
    height: "7px",
    width: "7px",
    alignSelf:"center"
  },
  tooltipValue:{
    fontSize: 11, 
    color: "#14191C", 
    marginTop: 5,
    fontWeight:700,
    fontFamily:"Lato",
    alignSelf:"center"
  }
}))

const GroupBarChartTooltip = (props: any) => {
  const classes = useStyles();

  return (
    <div style={{ height: "55px", width: "100px", backgroundColor: "#ffffff", position: "relative" }}>
      <div style={{ textAlign: "center", height: "18px" }}>
        <h6 style={{ fontSize: 11, color: "#8B95A0", marginTop: "5px" }}>{props.data.date}</h6>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          height: "7px",
          paddingBottom: 0,
          marginBottom: 0,
        }}
      >
           <div style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#4E9E73" }} >.</div>
           <h6 className={classes.tooltipValue} style={{ color: "#000" }}>{props.data["Total transfers"] ? props.data["Total transfers"] : 0}</h6>
        </div>
        <div  style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#FFCE00" }} >.</div>
          <h6 className={classes.tooltipValue} style={{ color: "#14191C" }}>{props.data["Pickup time delayed"] ? props.data["Pickup time delayed"] : 0}</h6>
        </div>
        <div  style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#CC3D49" }} >.</div>
          <h6 className={classes.tooltipValue} style={{ color: "#14191C" }}> {props.data["Transfers delayed"] ? props.data["Transfers delayed"] : 0}</h6>
        </div>
        <div  style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#620707" }} >.</div>
          <h6 className={classes.tooltipValue} style={{ color: "#14191C" }}> {props.data["Aborted"] ? props.data["Aborted"] : 0}</h6>

        </div>
      </div>
      
      <div style={{ position: "absolute", height: "18px", width: "20px", backgroundColor: "#ffffff", top: 40, left: 38, transform: `rotate(45deg)`, zIndex: -1 }}></div>
    </div>
  );
};

export default GroupBarChartTooltip;
